import { ButtonTab } from "@/components/Button/ButtonTab"
import { PageTitle } from "@/components/Layout/PageTitle"
import { TransactionsCard } from "@/components/Transactions/Card"
import { TransactionsExchange } from "@/components/Transactions/Exchange"
import { ClientType, selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import { memo } from "react"
import { FormattedMessage } from "react-intl"
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom"

const TransactionsPageComponent = () => {
  const { client_type, card_active } = useStoreClient(selectUser)
  const isCorporateAccount = client_type === ClientType.Coroporate
  const { path } = useRouteMatch()
  return (
    <>
      <PageTitle title_id="trans_history" showBuyCoins contentClass="w-full md:w-auto">
        {!isCorporateAccount && card_active && (
          <ButtonTab
            items={[
              {
                title: <FormattedMessage id="exchange" />,
                to: `${path}/exchange`,
              },
              {
                title: <FormattedMessage id="card" />,
                to: `${path}/card`,
              },
            ]}
          />
        )}
      </PageTitle>
      <Switch>
        <Route path={`${path}/exchange`}>
          <TransactionsExchange />
        </Route>
        <Route path={`${path}/card/:id?`}>
          <TransactionsCard isOrders />
        </Route>
        <Redirect to={`${path}/exchange`} />
      </Switch>
    </>
  )
}

export const TransactionsPage = memo(TransactionsPageComponent)
